const MEANS_OPTIONS = [
    { label: "GA087WW", value: "GA087WW" },
    { label: "GE111MA", value: "GE111MA" },
    { label: "GE195MA", value: "GE195MA" },
    { label: "GH155ZZ", value: "GH155ZZ" },
    { label: "GS441DK", value: "GS441DK" },
    { label: "GB551GC", value: "GB551GC" },
    { label: "GX239WD", value: "GX239WD" },
    { label: "GS275JB", value: "GS275JB" },
    { label: "EH899YN", value: "EH899YN" },
    { label: "FB757SB", value: "FB757SB" },
    { label: "FJ715HN", value: "FJ715HN" },

  ];
  
  export default MEANS_OPTIONS;
  